import React from 'react';
import { TableList } from '../../../common/components/TableList';
import Row from './Row';

/**
 * Pure presentation component for tournament awards list
 * Handles only the display of data without any business logic
 */
const TournamentAwardsListPresentation = ({
  awards,
  loading,
  headers,
  query,
  pagination,
  total,
  onPaginate,
  onSort,
  onRowClick
}) => (
  <TableList
    tableData={awards}
    tableHeaders={headers}
    query={query}
    onSort={onSort || (() => {})}
    Row={Row}
    rowCallback={onRowClick}
    loading={loading}
    pagination={pagination || { page: 1, itemsPerPage: 10 }}
    total={total || (awards ? awards.length : 0)}
    onPaginate={onPaginate || (() => {})}
  />
);

export default TournamentAwardsListPresentation;
